<template>
    <!--    <div id="InventoryHistory">-->
    <div class="row" id="InventoryHistory" style="max-width: 1200px !important; min-height: 95vh">
        <div class="card q-pa-md" style="width: 1200px !important; min-height: 95vh">
            <div class="row">
                <div class="app-fixed-header" style="width: 1200px; left: unset; top: 25px !important; right: 0px !important;">
                    <div class="d-flex justify-content-between w-100" style="align-items: center; height: 60px;">
                        <h4 style="font-size: 26px; font-weight: 300; margin-left: 25px; ">
                            Batch History
                        </h4>
                        <div class="d-flex" style="justify-content: space-between">
                            <q-btn @click="closeDialog" flat icon="close" round size="small"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row q-pa-md" style="margin-top: 50px;">
                <div class="col-5">
                    <q-input class="searchBox" placeholder="Enter Batch No" v-model="batch"/>
                </div>
                <div class="col-4 pl-3 text-left d-flex align-center">
                    <q-btn @click="getBatchHistory" class="pd-btn">GET HISTORY</q-btn>
                </div>
                <div class="col-3 pl-3 text-right">
                    <q-btn @click="changeSortOrder" class="pd-btn" icon="sort" round></q-btn>
                </div>
            </div>

            <div class="row text-left">
                <q-timeline color="blue-10" style="font-size: 16px !important; margin-top: 50px;" v-if="batchOrder">
                    <template v-if="sortBy==='desc'">
                        <q-timeline-entry :subtitle="`Owned By ${batchOrder.OwnedBy.name}`"
                                          :title="`#${batchOrder.batch}`"></q-timeline-entry>
                    </template>
                    <template v-else-if="sortBy==='asc'">
                        <q-timeline-entry
                                :subtitle="`Created By ${batchOrder.CreatedBy.name} On ${dateTimeFilter(batchOrder.createdOn)}`"
                                :title="`#${batchOrder.batch}`"></q-timeline-entry>
                    </template>
                    <template v-for="(order,index) in orderHistory">
                        <q-timeline-entry title="Batch is Transferred">
                            <q-card>
                                <q-card-section>
                                    <div class="mp-card" style="height: 100%;">
                                        <div class="mp-header">
                                            <div class="d-flex justify-content-between" style="align-items: center">
                                                <div class="d-flex">
                                                    <div class="text-left mr-5">
                                                        <span class="bankLabel">Order ID</span>
                                                        <h4 style="font-size: 22px; line-height: 1.5rem; font-weight: 300; ">
                                                            {{order.orderNum}}
                                                        </h4>
                                                    </div>
                                                    <div class="text-left mr-5">
                                                        <span class="bankLabel">Order On</span>
                                                        <h4 style="font-size: 22px; line-height: 1.5rem; font-weight: 300; ">
                                                            {{dateTimeFilter(order.updatedOn)}}
                                                        </h4>
                                                    </div>
                                                </div>
                                                <div>
                                                    <span class="mp-item-count text-uppercase">{{order.status}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <hr class="my-2" style="border: 0.5px solid lightgray">
                                        <div class="mp-body">
                                            <ul class="d-flex py-3 " style="list-style: none; align-items: center">
                                                <li>
                                                    <div>
                                                        <span class="bankLabel">Order From</span>
                                                        <div class="mp-value">
                                                            <span>{{order.FromOrganization?order.FromOrganization.name:'-'}} ({{order.FromOrganization.PartnerType.prefix}})</span>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="ml-5">
                                                    <div>
                                                        <span class="bankLabel">To</span>
                                                        <div class="mp-value">
                                                            <span>
                                                                {{order.orderType=='2'?(order.ToCustomer?order.ToCustomer.name:'-'): (order.ToOrganization?order.ToOrganization.name:'-')}} ({{order.orderType=='2'?'Retail Sales':(order.ToOrganization&&order.ToOrganization.PartnerType.prefix)}})
                                                            </span>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="ml-5">
                                                    <div>
                                                        <span class="bankLabel">By</span>
                                                        <div class="mp-value">
                                                            <span>{{order.PlacedBy?order.PlacedBy.name:'-'}}</span>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </q-card-section>
                            </q-card>
                        </q-timeline-entry>
                    </template>
                    <template v-if="sortBy==='desc'">
                        <q-timeline-entry
                                :subtitle="`Created By ${batchOrder.CreatedBy.name} On ${dateTimeFilter(batchOrder.createdOn)}`"
                                :title="`#${batchOrder.batch}`"></q-timeline-entry>
                    </template>
                    <template v-else-if="sortBy==='asc'">
                        <q-timeline-entry :subtitle="`Owned By ${batchOrder.OwnedBy.name}`"
                                          :title="`#${batchOrder.batch}`"></q-timeline-entry>
                    </template>

                </q-timeline>
            </div>
        </div>
    </div>
    <!--    </div>-->
</template>

<script>
  import { GET_BATCH_FROM_BATCHNO, GET_ORDER_HISTORY } from '../../graphql/queries/batch'

  export default {
    name: 'InventoryHistory',
    data () {return { batchOrder: null, orderHistory: [], batch: '', batchTemp: '',sortBy: 'asc'  }},
    apollo: {
      BatchTable: {
        query: GET_BATCH_FROM_BATCHNO,
        skip: true,
        variables () {
          return { batch: this.batchTemp.trim().toUpperCase() }
        },
        result ({ data, loading }) {
          if (!loading) {
            this.batchOrder = data.BatchTable ? data.BatchTable[0] : []
            this.$apollo.queries.Orders.skip = false
          }
        },
      },
      Orders: {
        query: GET_ORDER_HISTORY,
        skip: true,
        variables () {
          return { batch: this.batchTemp.trim().toUpperCase() ,sortBy: { createdOn: this.sortBy }}
        },
        result ({ data, loading }) {
          if (!loading) {
            this.orderHistory = data.Orders
          }
        },
      },
    },
    methods: {
      getBatchHistory () {
        this.batchTemp = this.batch
        if (this.batch) {
          this.$apollo.queries.BatchTable.skip = false
        } else {
          alert('Please Enter Batch')
        }
      },
      changeSortOrder () {
        this.sortBy = this.sortBy === 'desc' ? 'asc' : 'desc'
      },
      closeDialog () {
        this.$emit('closeInventoryHistoryDialog')
      },
    },
  }
</script>

<style scoped>
    .card {
        text-align: center;
        width: 100%;
        background-color: #fff;
        background-repeat: no-repeat;
        background-position: bottom;
        border-radius: 4px;
        box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
        position: relative;
    }
</style>
